export const SWITCH_MEMBER_SCREEN_LOADING_REQUEST = 'SWITCH_MEMBER_SCREEN_LOADING_REQUEST';
export const SWITCH_MEMBER_SCREEN_LOADING_SUCCESS = 'SWITCH_MEMBER_SCREEN_LOADING_SUCCESS';
export const SWITCH_MEMBER_SCREEN_LOADING_FAILURE = 'SWITCH_MEMBER_SCREEN_LOADING_FAILURE';
export const SWOP_USER_REQUEST = 'SWOP_USER_REQUEST';
export const SWOP_USER_SUCCESS = 'SWOP_USER_SUCCESS';
export const SWOP_USER_FAILURE = 'SWOP_USER_FAILURE';
export const INVITE_FAMILY_MEMBER_REQUEST = 'INVITE_FAMILY_MEMBER_REQUEST';
export const INVITE_FAMILY_MEMBER_SUCCESS = 'INVITE_FAMILY_MEMBER_SUCCESS';
export const INVITE_FAMILY_MEMBER_FAILURE = 'INVITE_FAMILY_MEMBER_FAILURE';
export const ACCEPT_FAMILY_PLAN_INVITATION_REQUEST = 'ACCEPT_FAMILY_PLAN_INVITATION_REQUEST';
export const ACCEPT_FAMILY_PLAN_INVITATION_SUCCESS= 'ACCEPT_FAMILY_PLAN_INVITATION_SUCCESS';
export const ACCEPT_FAMILY_PLAN_INVITATION_FAILURE = 'ACCEPT_FAMILY_PLAN_INVITATION_FAILURE';
export const LOAD_INVITATION_CODE_SIGNUP_SCREEN = 'load_Invitation_Code_Signup_Screen';
export const CLOSE_INVITATION_CODE_WELCOME_SCREEN = 'close_Invitation_Code_Welcome_Screen';
export const LOAD_INVITE_MEMBER_SCREEN = 'load_invite_member_Screen';
export const LOAD_CONFIRM_REMOVE_SCREEN = 'load_confirm_remove_screen';
export const CANCEL_PENDING_FAMILY_PLAN_INVITATION_REQUEST = 'CANCEL_PENDING_FAMILY_PLAN_INVITATION_REQUEST';
export const CANCEL_PENDING_FAMILY_PLAN_INVITATION_SUCCESS= 'CANCEL_PENDING_FAMILY_PLAN_INVITATION_SUCCESS';
export const CANCEL_PENDING_FAMILY_PLAN_INVITATION_FAILURE = 'CANCEL_PENDING_FAMILY_PLAN_INVITATION_FAILURE';
export const UPDATE_USER_PROFILE_COLOR_REQUEST = 'UPDATE_USER_PROFILE_COLOR_REQUEST';
export const UPDATE_USER_PROFILE_COLOR_SUCCESS = 'UPDATE_USER_PROFILE_COLOR_SUCCESS';
export const UPDATE_USER_PROFILE_COLOR_FAILURE = 'UPDATE_USER_PROFILE_COLOR_FAILURE';
export const REMOVE_FAMILY_PLAN_MEMBER_REQUEST = 'REMOVE_FAMILY_PLAN_MEMBER_REQUEST';
export const REMOVE_FAMILY_PLAN_MEMBER_SUCCESS = 'REMOVE_FAMILY_PLAN_MEMBER_SUCCESS';
export const REMOVE_FAMILY_PLAN_MEMBER_FAILURE = 'REMOVE_FAMILY_PLAN_MEMBER_FAILURE';
export const UPDATE_USER_PROFILE_PIN_REQUEST = 'UPDATE_USER_PROFILE_PIN_REQUEST';
export const UPDATE_USER_PROFILE_PIN_SUCCESS = 'UPDATE_USER_PROFILE_PIN_SUCCESS';
export const UPDATE_USER_PROFILE_PIN_FAILURE = 'UPDATE_USER_PROFILE_PIN_FAILURE';
export const MANAGE_MEMBERS = 'manage_members';
export const MANAGE_MEMBERS_DONE = 'manage_members_done';
export const PIN_ATTEMPT_CHANGED = 'PIN_ATTEMPT_CHANGED';
